import React from "react";
import { useLanguage } from "context/LanguageProvider";

const ModeToggle = ({ isProgramming, onToggle }) => {
  const { selLanguage } = useLanguage();

  return (
    <div className="mode-toggle-wrapper">
      <span className={`mode-label ${!isProgramming ? "active" : "inactive"}`}>
        {selLanguage ? "Δομές Δεδομένων" : "Data Structures"}
      </span>

      <div
        className="toggle-track"
        onClick={onToggle}
        style={{
          background: isProgramming
            ? "linear-gradient(135deg, #0e6b0e, #2b5320)"
            : "#5e72e4",
          transition: "background 0.4s ease",
        }}
      >
        <div className={`toggle-thumb ${isProgramming ? "right" : "left"}`} />
      </div>

      <span
        className={`mode-label ${isProgramming ? "active" : "inactive"}`}
        style={
          isProgramming
            ? {
              color: "#649568",
            }
            : {}
        }
      >
        {selLanguage ? "Προγραμματισμός" : "Programming"}
      </span>
    </div>
  );
};

export default ModeToggle;